<template>
  <div class="home">
    <editPage></editPage>
  </div>
</template>

<style scoped></style>

<script>
import editPage from "../components/editPage.vue"
export default {
  name: "home",
  components: { editPage },
  computed: {},
  mounted() {
    this.escHandle()
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.keyDownEvent)
  },
  methods: {
    escHandle() {
      document.addEventListener("keydown", this.keyDownEvent)
    },
    keyDownEvent() {
      let _this = this
      let key = window.event.keyCode
      // esc键   取消克隆模式
      if (key === 27 && _this.$store.state.states.isClonePattern) {
        _this.$store.commit("states/changeGeneralAttr", {
          valName: "isClonePattern",
          val: false
        })
      }
      // esc键   取消排序模式
      if (key === 27 && _this.$store.state.states.isOrderPattern) {
        _this.$store.commit("states/changeGeneralAttr", {
          valName: "isOrderPattern",
          val: false
        })
      }
    }
  }
}
</script>
